import Variables from "@/views/CMS/Variables/Variables.vue";
const routes = [
    {
        path: "/cms/variables/list",
        name: "Variables",
        component: Variables,
    },
];
export default routes;
